import React from "react";

import { RequestCloudFileFixDialog } from "../../common/components/request-cloud-fix/RequestCloudFileFixDialog";
import { CloudFileListingItem } from "../types/CloudFileListingItem";

export interface RequestCloudFileFixButtonDialogProps {
    item: CloudFileListingItem;
    onClose(): void;
    isOpen: boolean;
}

export const RequestCloudFileFixButtonDialog: React.VFC<RequestCloudFileFixButtonDialogProps> = ({
    item,
    isOpen,
    onClose
}: RequestCloudFileFixButtonDialogProps) => {
    return (
        <RequestCloudFileFixDialog
            deliveryFileName={item.deliveryFileName}
            filePath={item.filePath}
            onClose={onClose}
            isOpen={isOpen}
            cloudFileId={item.id}
        />
    );
};
